/** Frontend-API für die Decisions-Sicht (compass-new Layer 3, read-only). */

export interface DecisionRow {
  id: number;
  signalStreamId: string;
  type: string;
  route: string;
  companyId: number | null;
  pillar: string | null;
  kind: string | null;
  score: number | null;
  reason: string | null;
  missing: string[] | null;
  traceId: string | null;
  occurredAt: string;
}

export async function listDecisions(): Promise<DecisionRow[]> {
  const res = await fetch('/api/decisions');
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  const body = (await res.json()) as { decisions: DecisionRow[] };
  return body.decisions;
}
